import React from 'react';
export function ThreeLevels() {
  return <section className="w-full bg-slate-50 py-12 md:py-20 px-4" data-id="element-433">
      <div className="max-w-6xl mx-auto" data-id="element-434">
        <div className="text-center mb-12" data-id="element-435">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-3" data-id="element-436">
            Tres niveles. Un solo objetivo.
          </h2>
          <p className="text-xl text-brand-blue font-medium mb-2" data-id="element-437">
            Elegí según dónde estás en la carrera
          </p>
          <p className="text-slate-500" data-id="element-438">
            Material construido sobre los planes de estudio oficiales de UBA,
            UNLP, UNC...
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-439">
          {/* Card 1 */}
          <div className="bg-white rounded-2xl p-6 shadow-sm border border-slate-200 flex flex-col" data-id="element-440">
            <div className="inline-block bg-slate-100 text-slate-800 font-bold px-3 py-1 rounded-full text-sm mb-4 self-start" data-id="element-441">
              Médico en Proceso™ Nivel 1
            </div>
            <p className="text-slate-600 mb-6 flex-grow" data-id="element-442">
              El contenido central de toda la carrera de Medicina, organizado
              por ejes y listo para estudiar desde el primer día.
            </p>
            <div className="flex flex-col gap-2 text-sm font-medium text-slate-700" data-id="element-443">
              <div className="flex items-center gap-2" data-id="element-444">
                <span data-id="element-445">📚</span> 6 Tomos
              </div>
              <div className="flex items-center gap-2" data-id="element-446">
                <span data-id="element-447">🎁</span> 6 Bonos
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-white rounded-2xl p-6 shadow-md border-2 border-brand-blue flex flex-col relative transform md:-translate-y-2" data-id="element-448">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-blue text-white font-bold px-4 py-1 rounded-full text-xs whitespace-nowrap" data-id="element-449">
              ⭐ MÁS ELEGIDO
            </div>
            <div className="inline-block bg-blue-50 text-brand-blue font-bold px-3 py-1 rounded-full text-sm mb-4 self-start mt-2" data-id="element-450">
              Sistema Carrera Organizada™ Nivel 2
            </div>
            <p className="text-slate-600 mb-6 flex-grow" data-id="element-451">
              Todo el Megapack más un sistema para planificar, organizarte y no
              improvisar más en Guardia ni en Medicina Interna.
            </p>
            <div className="flex flex-col gap-2 text-sm font-medium text-slate-700" data-id="element-452">
              <div className="flex items-center gap-2" data-id="element-453">
                <span data-id="element-454">📚</span> Todo el Nivel 1
              </div>
              <div className="flex items-center gap-2" data-id="element-455">
                <span data-id="element-456">🏥</span> Tomo Guardia
              </div>
              <div className="flex items-center gap-2" data-id="element-457">
                <span data-id="element-458">📝</span> Tomo Medicina Interna
              </div>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-white rounded-2xl p-6 shadow-md border-2 border-brand-amber flex flex-col relative" data-id="element-459">
            <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-brand-amber text-white font-bold px-4 py-1 rounded-full text-xs whitespace-nowrap" data-id="element-460">
              🏆 MÁS COMPLETO
            </div>
            <div className="inline-block bg-amber-50 text-brand-amber font-bold px-3 py-1 rounded-full text-sm mb-4 self-start mt-2" data-id="element-461">
              Sistema de Gestión Académica™ Nivel 3
            </div>
            <p className="text-slate-600 mb-6 flex-grow" data-id="element-462">
              La versión completa. Todo el sistema más 7 editables premium para
              dominar cada materia y organizar toda la carrera.
            </p>
            <div className="flex flex-col gap-2 text-sm font-medium text-slate-700" data-id="element-463">
              <div className="flex items-center gap-2" data-id="element-464">
                <span data-id="element-465">🏆</span> Todo el Nivel 2
              </div>
              <div className="flex items-center gap-2" data-id="element-466">
                <span data-id="element-467">✏️</span> 7 Editables premium
              </div>
            </div>
          </div>
        </div>

        <div className="text-center text-slate-500 font-medium" data-id="element-468">
          👇 Más abajo te mostramos en detalle qué incluye cada nivel, qué
          materias cubre y por qué está organizado así.
        </div>
      </div>
    </section>;
}